<div class="custos-cabecalho">
  <div>
    <h4 class="mb-1">Custos do estoque </h4>
    <p class="text-muted mb-0">Posição atual, movimentações processadas e evolução do custo médio.</p>
  </div>
</div>

<div class="custos-resumo">
  <div class="custos-card">
    <small>Valor físico do estoque</small>
    <strong>{{resumoPosicao.valorTotal == null ? '—' : (resumoPosicao.valorTotal | currency:'BRL')}}</strong>
  </div>
  <div class="custos-card">
    <small>Insumos controlados</small>
    <strong>{{resumoPosicao.total || 0}}</strong>
  </div>
  <div class="custos-card" [class.custos-card-alerta]="resumoPosicao.pendenciasCusto">
    <small>Sem custo conhecido</small>
    <strong>{{resumoPosicao.pendenciasCusto || 0}}</strong>
  </div>
  <div class="custos-card" [class.custos-card-erro]="inconsistencias.length">
    <small>Inconsistências</small>
    <strong>{{inconsistencias.length}}</strong>
  </div>
</div>

<kendo-tabstrip #abasRelatorios class="nav-bordered custos-abas" (tabSelect)="selecionouRelatorio($event)">
  <kendo-tabstrip-tab title="Posição atual" [selected]="true">
    <ng-template kendoTabContent>
      <div class="custos-filtros">
        <div class="custos-filtro custos-filtro-busca">
          <label>Buscar insumo</label>
          <input kendoTextBox class="form-control" placeholder="Nome ou código" [(ngModel)]="filtroPosicao.texto">
        </div>
        <div class="custos-filtro">
          <label>Grupo</label>
          <kendo-combobox class="form-control"
                          [data]="grupos"
                          textField="nome"
                          valueField="id"
                          [allowCustom]="false"
                          placeholder="Todos os grupos"
                          [(ngModel)]="filtroPosicao.grupo">
          </kendo-combobox>
        </div>
        <button type="button" class="btn btn-blue" (click)="apliqueFiltroPosicao()">Aplicar</button>
        <a class="btn btn-outline-secondary"
           [href]="obtenhaUrlCsvPosicao()"
           download="posicao-estoque.csv">
          <i class="fa fa-download mr-1"></i> CSV
        </a>
      </div>

      <div class="alert alert-danger" *ngIf="erroPosicao">{{erroPosicao}}</div>

      <kendo-grid class="custos-grid"
                  [loading]="carregandoPosicao"
                  [data]="posicao"
                  [pageSize]="tamanhoPosicao"
                  [skip]="skipPosicao"
                  [pageable]="true"
                  [resizable]="true"
                  (pageChange)="mudouPaginaPosicao($event)">
        <kendo-grid-messages noRecords="Nenhum insumo encontrado" loading="Carregando"></kendo-grid-messages>

        <kendo-grid-column title="Insumo" [width]="260">
          <ng-template kendoGridCellTemplate let-item>
            <small class="d-block text-muted">{{item.grupo || 'Sem grupo'}} · {{item.codigo || 'Sem código'}}</small>
            <strong>{{item.insumo}}</strong>
          </ng-template>
        </kendo-grid-column>
        <kendo-grid-column title="Quantidades" [width]="250">
          <ng-template kendoGridCellTemplate let-item>
            <div><small class="text-muted">Físico:</small> <b>{{item.quantidadeFisica}} {{item.unidade}}</b></div>
            <div><small class="text-muted">Reservado:</small> {{item.quantidadeReservada}} {{item.unidade}}</div>
            <div><small class="text-muted">Disponível:</small> {{item.quantidadeDisponivel}} {{item.unidade}}</div>
          </ng-template>
        </kendo-grid-column>
        <kendo-grid-column title="Custo médio" [width]="170">
          <ng-template kendoGridCellTemplate let-item>
            <strong *ngIf="item.custoMedio != null">{{item.custoMedio | currency:'BRL'}}</strong>
            <span class="text-warning" *ngIf="item.custoMedio == null">Desconhecido</span>
          </ng-template>
        </kendo-grid-column>
        <kendo-grid-column title="Valores" [width]="230">
          <ng-template kendoGridCellTemplate let-item>
            <div><small class="text-muted">Físico:</small> {{item.valorFisico == null ? '—' : (item.valorFisico | currency:'BRL')}}</div>
            <div><small class="text-muted">Disponível:</small> {{item.valorDisponivel == null ? '—' : (item.valorDisponivel | currency:'BRL')}}</div>
          </ng-template>
        </kendo-grid-column>
        <kendo-grid-column title="" [width]="130">
          <ng-template kendoGridCellTemplate let-item>
            <button type="button" class="btn btn-sm btn-outline-primary" (click)="abraEvolucao(item)">
              Ver evolução
            </button>
          </ng-template>
        </kendo-grid-column>
      </kendo-grid>
    </ng-template>
  </kendo-tabstrip-tab>

  <kendo-tabstrip-tab title="Movimentações valorizadas">
    <ng-template kendoTabContent>
      <div class="movimentacoes-resumo">
        <span><b>{{resumoMovimentacoes.total || 0}}</b> movimentações processadas</span>
        <span>Custo movimentado: <b>{{resumoMovimentacoes.custoTotalMovimentado == null ? '—' : (resumoMovimentacoes.custoTotalMovimentado | currency:'BRL')}}</b></span>
      </div>

      <div class="custos-filtros">
        <div class="custos-filtro custos-filtro-data">
          <label>De</label>
          <kendo-datepicker class="form-control" [(ngModel)]="filtroMovimentacoes.inicio" [format]="'dd/MM/yyyy'"></kendo-datepicker>
        </div>
        <div class="custos-filtro custos-filtro-data">
          <label>Até</label>
          <kendo-datepicker class="form-control" [(ngModel)]="filtroMovimentacoes.fim" [format]="'dd/MM/yyyy'"></kendo-datepicker>
        </div>
        <div class="custos-filtro">
          <label>Grupo</label>
          <kendo-combobox class="form-control" [data]="grupos" textField="nome" valueField="id"
                          [allowCustom]="false" placeholder="Todos" [(ngModel)]="filtroMovimentacoes.grupo">
          </kendo-combobox>
        </div>
        <div class="custos-filtro custos-filtro-insumo">
          <label>Insumo</label>
          <kendo-combobox class="form-control" [data]="insumosMovimentacao" textField="nome" valueField="id"
                          [allowCustom]="false" [filterable]="true" placeholder="Todos"
                          (filterChange)="filtreInsumosMovimentacao($event)"
                          [(ngModel)]="filtroMovimentacoes.insumo">
          </kendo-combobox>
        </div>
        <div class="custos-filtro">
          <label>Tipo</label>
          <kendo-dropdownlist class="form-control" [data]="tiposMovimentacao" textField="nome" valueField="valor"
                              [(ngModel)]="filtroMovimentacoes.tipo">
          </kendo-dropdownlist>
        </div>
        <button type="button" class="btn btn-blue" (click)="apliqueFiltroMovimentacoes()">Aplicar</button>
        <a class="btn btn-outline-secondary" [href]="obtenhaUrlCsvMovimentacoes()" download="movimentacoes-valorizadas.csv">
          <i class="fa fa-download mr-1"></i> CSV
        </a>
      </div>

      <div class="alert alert-danger" *ngIf="erroMovimentacoes">{{erroMovimentacoes}}</div>

      <kendo-grid class="custos-grid"
                  [loading]="carregandoMovimentacoes"
                  [data]="movimentacoes"
                  [pageSize]="tamanhoMovimentacoes"
                  [skip]="skipMovimentacoes"
                  [pageable]="true"
                  [resizable]="true"
                  (pageChange)="mudouPaginaMovimentacoes($event)">
        <kendo-grid-messages noRecords="Nenhuma movimentação valorizada encontrada" loading="Carregando"></kendo-grid-messages>

        <kendo-grid-column title="Movimentação" [width]="180">
          <ng-template kendoGridCellTemplate let-item>
            <small class="d-block text-muted">#{{item.idMovimentacao}}</small>
            <strong class="text-capitalize">{{item.tipo}}</strong>
            <small class="d-block text-muted">{{item.motivo || '—'}}</small>
          </ng-template>
        </kendo-grid-column>
        <kendo-grid-column title="Insumo" [width]="220">
          <ng-template kendoGridCellTemplate let-item>
            <small class="d-block text-muted">{{item.codigo || 'Sem código'}}</small>
            <strong>{{item.insumo}}</strong>
          </ng-template>
        </kendo-grid-column>
        <kendo-grid-column title="Quantidade" [width]="130">
          <ng-template kendoGridCellTemplate let-item>
            <strong [ngClass]="{'text-success': item.quantidade > 0, 'text-danger': item.quantidade < 0}">
              {{item.quantidade}} {{item.unidade}}
            </strong>
          </ng-template>
        </kendo-grid-column>
        <kendo-grid-column title="Custos" [width]="190">
          <ng-template kendoGridCellTemplate let-item>
            <div><small class="text-muted">Unitário:</small> {{item.custoUnitario | currency:'BRL'}}</div>
            <div><small class="text-muted">Total:</small> <b>{{item.custoTotal | currency:'BRL'}}</b></div>
          </ng-template>
        </kendo-grid-column>
        <kendo-grid-column title="Custo médio" [width]="210">
          <ng-template kendoGridCellTemplate let-item>
            {{item.custoMedioAnterior == null ? '—' : (item.custoMedioAnterior | currency:'BRL')}}
            → <b>{{item.custoMedioResultante | currency:'BRL'}}</b>
          </ng-template>
        </kendo-grid-column>
        <kendo-grid-column title="Saldo / valor" [width]="180">
          <ng-template kendoGridCellTemplate let-item>
            <div>{{item.saldoQuantidadeResultante}} {{item.unidade}}</div>
            <small class="text-muted">{{item.valorResultante | currency:'BRL'}}</small>
          </ng-template>
        </kendo-grid-column>
        <kendo-grid-column title="Processamento" [width]="220">
          <ng-template kendoGridCellTemplate let-item>
            <div>{{item.processadoEm | date:'dd/MM/yyyy HH:mm:ss'}}</div>
            <small class="text-muted" *ngIf="item.operador">{{item.operador}}</small>
          </ng-template>
        </kendo-grid-column>
      </kendo-grid>
    </ng-template>
  </kendo-tabstrip-tab>

  <kendo-tabstrip-tab title="Evolução do custo médio">
    <ng-template kendoTabContent>
      <div class="custos-filtros">
        <div class="custos-filtro custos-filtro-insumo">
          <label>Insumo</label>
          <kendo-combobox class="form-control" [data]="insumosEvolucao" textField="nome" valueField="id"
                          [allowCustom]="false" [filterable]="true" placeholder="Selecione"
                          (filterChange)="filtreInsumosEvolucao($event)"
                          [(ngModel)]="filtroEvolucao.insumo">
          </kendo-combobox>
        </div>
        <div class="custos-filtro custos-filtro-data">
          <label>De</label>
          <kendo-datepicker class="form-control" [(ngModel)]="filtroEvolucao.inicio" [format]="'dd/MM/yyyy'"></kendo-datepicker>
        </div>
        <div class="custos-filtro custos-filtro-data">
          <label>Até</label>
          <kendo-datepicker class="form-control" [(ngModel)]="filtroEvolucao.fim" [format]="'dd/MM/yyyy'"></kendo-datepicker>
        </div>
        <button type="button" class="btn btn-blue" (click)="carregueEvolucao()">Consultar</button>
      </div>

      <div class="alert alert-danger" *ngIf="erroEvolucao">{{erroEvolucao}}</div>
      <div class="alert alert-info" *ngIf="!filtroEvolucao.insumo && !erroEvolucao">
        Selecione um insumo para visualizar a evolução do custo médio.
      </div>

      <ng-container *ngIf="filtroEvolucao.insumo && !erroEvolucao">
        <div class="alert alert-light border" *ngIf="!carregandoEvolucao && !evolucao.length">
          Nenhuma alteração de custo médio encontrada no período.
        </div>
        <small class="d-block mb-2 text-muted" *ngIf="evolucao.length === 100">
          Exibindo até 100 alterações mais recentes. Reduza o período para detalhar mais.
        </small>

        <div class="evolucao-grafico" *ngIf="evolucao.length">
          <kendo-chart [style.height.px]="300">
            <kendo-chart-category-axis>
              <kendo-chart-category-axis-item [categories]="evolucaoCategorias">
                <kendo-chart-category-axis-item-labels [rotation]="-45"></kendo-chart-category-axis-item-labels>
              </kendo-chart-category-axis-item>
            </kendo-chart-category-axis>
            <kendo-chart-value-axis>
              <kendo-chart-value-axis-item>
                <kendo-chart-value-axis-item-labels format="c2"></kendo-chart-value-axis-item-labels>
              </kendo-chart-value-axis-item>
            </kendo-chart-value-axis>
            <kendo-chart-series>
              <kendo-chart-series-item [data]="evolucaoValores" [type]="'line'" [style]="'smooth'" color="#3b82f6">
                <kendo-chart-series-item-tooltip>
                  <ng-template let-value="value" let-category="category">
                    {{category}}: {{value | currency:'BRL'}}
                  </ng-template>
                </kendo-chart-series-item-tooltip>
              </kendo-chart-series-item>
            </kendo-chart-series>
            <kendo-chart-legend [visible]="false"></kendo-chart-legend>
          </kendo-chart>
        </div>

        <kendo-grid class="custos-grid" [loading]="carregandoEvolucao" [data]="evolucao" [resizable]="true" *ngIf="evolucao.length">
          <kendo-grid-column title="Movimentação" [width]="140">
            <ng-template kendoGridCellTemplate let-item>#{{item.idMovimentacao}}</ng-template>
          </kendo-grid-column>
          <kendo-grid-column title="Processamento" [width]="210">
            <ng-template kendoGridCellTemplate let-item>{{item.processadoEm | date:'dd/MM/yyyy HH:mm:ss'}}</ng-template>
          </kendo-grid-column>
          <kendo-grid-column title="Custo anterior" [width]="180">
            <ng-template kendoGridCellTemplate let-item>
              {{item.custoMedioAnterior == null ? '—' : (item.custoMedioAnterior | currency:'BRL')}}
            </ng-template>
          </kendo-grid-column>
          <kendo-grid-column title="Custo resultante" [width]="190">
            <ng-template kendoGridCellTemplate let-item><b>{{item.custoMedioResultante | currency:'BRL'}}</b></ng-template>
          </kendo-grid-column>
        </kendo-grid>
      </ng-container>
    </ng-template>
  </kendo-tabstrip-tab>

  <kendo-tabstrip-tab title="Alertas">
    <ng-template kendoTabContent>
      <div class="d-flex justify-content-end mb-3">
        <button type="button" class="btn btn-outline-secondary" (click)="carregueInconsistencias()" [disabled]="carregandoInconsistencias">
          <i class="fa fa-refresh mr-1"></i> Atualizar
        </button>
      </div>

      <div class="alert alert-danger" *ngIf="erroInconsistencias">{{erroInconsistencias}}</div>
      <div class="alert alert-success" *ngIf="!carregandoInconsistencias && !erroInconsistencias && !inconsistencias.length">
        <i class="fa fa-check-circle mr-1"></i> Nenhuma inconsistência financeira encontrada.
      </div>
      <div class="alert" [ngClass]="classeInconsistencia(item.tipo)" *ngFor="let item of inconsistencias">
        <strong>{{tituloInconsistencia(item.tipo)}} · {{item.insumo}}</strong>
        <div>{{item.descricao}}</div>
        <small *ngIf="item.diferenca != null">Diferença: {{item.diferenca | currency:'BRL'}}</small>
      </div>
    </ng-template>
  </kendo-tabstrip-tab>
</kendo-tabstrip>
